import { Component, ElementRef, input, output, viewChild } from '@angular/core';
import {
  CalendarTaskHeaderGroup,
  ResourcePaginationPipe,
} from '@infodata-group/inf-commons';

@Component({
  selector: 'infl-agenda-detailed-header',
  imports: [ResourcePaginationPipe],
  standalone: true,
  templateUrl: './agenda-detailed-header.component.html',
  styleUrl: './agenda-detailed-header.component.scss',
})
export class AgendaDetailedHeaderComponent {
  public resources = input<CalendarTaskHeaderGroup[]>([]);
  public resourceWidth = input(300);
  public paginationStep = input(5);
  public currentPage = input(1);

  protected headerElement = viewChild<ElementRef<HTMLDivElement>>('header');

  public scrollLeftAction = output<number>();

  public scrollLeft(scrollLeft: number) {
    this.headerElement().nativeElement.scrollLeft = scrollLeft;
  }

  protected onScroll($event: Event) {
    const target = $event.target as HTMLDivElement;
    this.scrollLeftAction.emit(target.scrollLeft);
  }
}
